import { useCallback, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { FormRow, Label, QueryDropdown } from 'basic-components';
import Query from 'dashboard-services/api/Query';
import { globalActions } from 'primary-components';

import getApiConfig from 'api/ApiConfig';
import { filesDatalakeQueries } from 'queries/modules/datalake';

const EMPTY_ARRAY = []

const toTemplateOption = ({ groupName, name }) => ({ value: `${groupName}/${name}`, label: name, tooltip: groupName, groupName, name })

const selectTemplates = data => (data?.pages || []).flatMap(page => page?.items || []).map(item => toTemplateOption({ groupName: item.groupName, name: item.fileName }))

const TemplateDropdown = ({ label, menuPortalTarget = undefined, name, onChange, template = undefined }) => {
  const dispatch = useDispatch(),
        getQueryBuilder = useCallback(() => new Query.Builder(dispatch(getApiConfig())).withFetching(false), [dispatch]),
        shouldBeLimited = useCallback(provider => dispatch(globalActions.shouldTheApiBeLimited(provider)), [dispatch]),
        [input, setInput] = useState(""),
        { data = EMPTY_ARRAY, isFetching, isFetchingNextPage, fetchNextPage } = filesDatalakeQueries.useSearchFiles({
          getQueryBuilder,
          query: `name=*${input}*.html&latest=true`,
          withStatus: false,
          shouldRefetch: false,
          shouldBeLimited,
          onSelect: selectTemplates
        }),
        defaultValue = useMemo(() => template ? toTemplateOption(template) : undefined, [template]),
        onChangeLocal = useCallback((_, { data }) => onChange(data ? { groupName: data.groupName, name: data.name } : null, { name }), [name, onChange])

  return (
    <FormRow isVertical>
      <Label>{label}</Label>
      <QueryDropdown
          defaultValue={defaultValue}
          fetchNextPage={fetchNextPage}
          isFetching={isFetching || isFetchingNextPage}
          menuPortalTarget={menuPortalTarget}
          name={name}
          noError
          onChange={onChangeLocal}
          onInputChange={setInput}
          options={data}
          placeholder="Leave empty for default"
          variant="border"
      />
    </FormRow>
  )
}

TemplateDropdown.propTypes = {
  label: PropTypes.string.isRequired,
  menuPortalTarget: PropTypes.object,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  template: PropTypes.object
}

export default TemplateDropdown
